export default "__VITE_ASSET__OC81rpCZ__"